// smsParts.ts · v12.10.31 (#2295 the 70-character-parts warning - never changes the text) · 2026-11-05 · VoiceSpectrum AI
// Tushar 11/5 12:41 AM (Q3 = b): "warn, never change the text". A text holding any character outside the standard GSM 7-bit set
// (curly quote, emoji, Chinese ...) is sent by the carrier as 70-character parts instead of 160. The plain keyboard apostrophe is in the set.
const GSM_BASIC = "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
const GSM_EXT = "^{}\\[~]|€";
const SET = new Set((GSM_BASIC + GSM_EXT).split(''));

/** The characters in `text` outside the standard text set (unique, in order). Tokens like {organization.phone} are plain ASCII. */
export function nonGsmChars(text: string): string[] {
  const out: string[] = [];
  for (const ch of Array.from(text ?? '')) if (!SET.has(ch) && !out.includes(ch)) out.push(ch);
  return out;
}

/** 160 (one part) / 153 per part, or 70 / 67 per part when a character outside the set is present. */
export function smsParts(text: string): { unicode: boolean; length: number; perPart: number; parts: number } {
  const unicode = nonGsmChars(text).length > 0;
  const length = unicode ? Array.from(text ?? '').length
    : Array.from(text ?? '').reduce((n, ch) => n + (GSM_EXT.includes(ch) ? 2 : 1), 0);
  const single = unicode ? 70 : 160, multi = unicode ? 67 : 153;
  const parts = length === 0 ? 0 : length <= single ? 1 : Math.ceil(length / multi);
  return { unicode, length, perPart: single, parts };
}
